// extracted by mini-css-extract-plugin
export default {"toggle":"_2lChr","selected":"_3MRMF","small":"Zff1D"};